import React from 'react';

const SectionHeader = ({ eyebrow, title, subtitle, align = 'left' }) => {
  const alignmentClass = align === 'center' ? 'text-center mx-auto' : 'text-left';

  return (
    <div className={`mb-10 max-w-2xl ${alignmentClass}`}>
      {eyebrow ? (
        <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-brand-accent">{eyebrow}</p>
      ) : null}
      <h2 className="section-title">{title}</h2>
      {subtitle ? <p className="mt-4 text-base md:text-lg leading-relaxed text-brand-muted">{subtitle}</p> : null}
    </div>
  );
};

export default SectionHeader;
